import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { MasterDataService, MasterData } from './master.data.service';


@Injectable()
export class InterfaceService {
  private baseApiUrl: string;
  private interestRateForList: Array<any>;

  constructor(configurationService: ConfigurationService,
    private masterDataService: MasterDataService,
    private masterData: MasterData,
    private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
    
  }


  submitInfo(selectedResult: { NationalId: string }): Observable<any> {
  const url = `${this.baseApiUrl}interface/submit-info`;
  return this.httpClient.post(url, selectedResult).pipe(
    map((res: any) => res),
    catchError((err: any) => {
      const errorMessage = err.error?.Message || err.message || 'Server error';
      return observableThrowError(() => new Error(errorMessage));
    })
  );
}
}